export default "__VITE_ASSET__ig3QO5vx__"